export const getPromptCredits = () => {
    return fetch('/api/v1/prompt-generation-credits/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const getDomainsApi = () => {
    return fetch('/api/v1/domains/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
